import { memo } from "react";
import { View } from "react-native";
import type { CompositionsLightType } from "skia-motion/src/CompositionsLight";
import Player from "skia-motion/src/player/Player";
import Loading from "../Loading";
import { SkiaPlayerProps } from "./types";

const BasicLoading = () => {
	return (
		<View
			style={{
				flex: 1,
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Loading />
		</View>
	);
};

const SkiaPlayer = <TComposition extends keyof CompositionsLightType>({
	LoadingComponent = BasicLoading,
	...rest
}: SkiaPlayerProps<TComposition> & {
	composition: TComposition;
}) => {
	return <Player {...rest} LoadingComponent={LoadingComponent as any} />;
};
export default memo(SkiaPlayer);
